import { render, staticRenderFns } from "./Today.vue?vue&type=template&id=12e704e4&"
import script from "./Today.vue?vue&type=script&lang=js&"
export * from "./Today.vue?vue&type=script&lang=js&"
import style0 from "./Today.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Today.vue"
export default component.exports